import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Código del Diagnóstico Invisible',
    subtitle: 'Por qué tu cuerpo lleva años enviando señales que nadie leyó',
    items: ['Entendés por primera vez qué está pasando en tu intestino', 'Conectás todos tus síntomas en un cuadro clínico coherente', 'Diferenciás síntomas de menopausia de síntomas digestivos', 'Descubrís el tipo de SIBO que probablemente tenés', 'Sabés exactamente qué pedirle al médico'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — El Rastreador de Precisión',
    subtitle: '30 días de registro que revelan tus patrones con datos reales',
    items: ['Dejás de adivinar qué te inflama y empezás a saberlo con certeza', 'Medís tu evolución con números, no con sensaciones', 'Descubrís la correlación real entre tu estrés y tu digestión', 'Construís el mapa completo de tu cuerpo en un documento', 'Llegás al médico con 30 días de evidencia irrefutable'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — Manual de Ingeniería Digestiva',
    subtitle: 'Las herramientas físicas para reactivar tu sistema de limpieza intestinal',
    items: ['Activás el mecanismo natural que el estrés apagó', 'Reducís la hinchazón con técnicas que no requieren ningún producto', 'Aprendés los horarios que tu intestino necesita para limpiar', 'Aplicás masajes que mueven el gas sin pastillas', 'Notás diferencia en la circunferencia abdominal antes de los 7 días'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — El Expediente de Autoridad Médica',
    subtitle: 'El documento que hace que el médico te escuche y pida los estudios correctos',
    items: ['Construís un informe clínico con tus datos reales', 'Aprendés el lenguaje médico para que no te minimicen', 'Sabés qué estudios pedir y por qué razón exacta', 'Tenés los scripts para cuando el médico dice "es la edad"', 'Pasás de ser ignorada a ser tomada en serio en la misma consulta'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — La Bóveda de Rescate y Estilo de Vida',
    subtitle: 'Tu kit de emergencia, tu libertad social y tu plan para que no vuelva',
    items: ['Sabés qué hacer en los próximos 10 minutos cuando hay una crisis', 'Volvés a salir a comer con estrategia en lugar de miedo', 'Tenés un plan concreto para sostener los resultados', 'Detectás señales de recurrencia antes de que el cuadro vuelva', 'Vivís sin organizar tu vida alrededor de los síntomas'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Checklist imprimibles por etapa', 'Recetas con ingredientes de tu feria', 'Registro de síntomas', 'Referencias científicas', '100% adaptado a la mujer argentina'];
  return <section className="py-24 bg-brand-dark" data-id="element-222">
      <div className="container mx-auto px-4" data-id="element-223">
        <div className="max-w-5xl mx-auto" data-id="element-224">
          <div className="text-center mb-16" data-id="element-225">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-226">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-227">
                SISTEMA BITÁCORA DE CONEXIÓN DIGESTIVA™
              </h2>
              <p className="text-white font-medium mb-2 text-[20px]" data-id="element-228">
                El protocolo paso a paso para identificar tus gatillos, activar
                tu intestino y recuperar la liviandad hoy mismo.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-229">
            📚 LOS 5 TOMOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-230">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-231">
                <div className="text-5xl shrink-0" data-id="element-232">{tomo.emoji}</div>
                <div data-id="element-233">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-234">
                    {tomo.title}
                  </h4>
                  <p className="text-sm text-brand-light italic mb-4" data-id="element-235">
                    {tomo.subtitle}
                  </p>
                  <ul className="space-y-2" data-id="element-236">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-237">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-238" />
                        <span data-id="element-239">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-240">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-241">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-242">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-243">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-244" />
                  <span className="text-gray-200" data-id="element-245">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}